























































































































































































































import * as moment from 'moment'
import Vue from 'vue'
import Component, {mixins} from 'vue-class-component'
import SEODetail from '@/modules/seo/components/SEODetail.vue'
import {Action, State, Mutation} from 'vuex-class'
import {Page, PageTranslation} from '@/modules/cms/types'
import LocaleSelectComponent from '@/modules/i18n/components/LocaleSelect.vue'
import PageTranslationSelectorComponent from '@/modules/cms/components/PageTranslationSelector.vue'
import Editor from '@/components/Editor.vue'
import {ActionTypes} from '@/modules/media/store/actions';
import {Config} from '@/modules/core/config';
import I18nMixin from '@/modules/i18n/mixins/I18nMixin';
import PagePreview from '@/modules/cms/components/PagePreview.vue';
import {MutationTypes} from '@/modules/cms/store/mutations'
import PageEmbeddedContent from '@/modules/cms/components/PageEmbeddedContent.vue';
import GallerySelect from '@/modules/cms/modules/gallery/components/GallerySelect.vue';
import {RootState} from '@/store/types';
import ModerationVoteList from '@/modules/cms/modules/moderation/components/ModerationVoteList.vue';
import TranslationSelect from '@/modules/i18n/components/TranslationSelect.vue';
import Loader from '@/components/Loader.vue';

@Component({
    components: {
        Loader,
        TranslationSelect,
        GallerySelect,
        PageEmbeddedContent,
        PagePreview,
        'seo-detail': SEODetail,
        'locale-select': LocaleSelectComponent,
        'page-translation-selector': PageTranslationSelectorComponent,
        Editor,
        ModerationVoteList,
    },
})
export default class PageDetail extends mixins(I18nMixin) {
    @Action('cms/savePage')
    public savePage: (payload?: { isNew: boolean }) => Page

    @Action('cms/buildNewPage')
    public buildNewPage: () => void

    @Action('cms/loadPagePreview')
    public loadPagePreview: () => Promise<void>

    @State(state => state.cms.loadingPage)
    public loadingPage: boolean

    @State(state => state.cms.currentPage)
    public page: Page

    @State(state => state.cms.currentTranslation)
    public translation: PageTranslation

    @State(state => state.cms.savingPage)
    public saving: boolean


    /**
     * Controla la visibilidad de la pantalla que muestra la vista previa de la página
     * estática
     */
    @Mutation(`cms/${MutationTypes.TogglePagePreview}`)
    public togglePagePreview: (show: boolean) => void

    @Mutation('cms/page/current/translation/field/update')
    public updateTranslationField: (payload: { path: string, value: any }) => void

    @Mutation(`cms/${MutationTypes.UpdateCurrentPageField}`)
    public updateField: (payload: { field: string, value: any }) => void

    public get isPrivate () {
        return this.page.isPrivate
    }

    public set isPrivate (value: boolean) {
        this.updateField({field: 'isPrivate', value})
    }

    public async save () {
        await this.savePage({isNew: !this.page.id})
        this.saveConfirmDialog = false
    }

    public floatingEditor = false
    public contentTab = null
    public moderationVoteList = false

    public get canInsertGallery (): boolean {
        return (this.$store.state as RootState).config.get('pages.allowInsertGallery', false)
    }

    /**
     * Acción para obtener una página de la api y cargarla en el estado
     * de la aplicación
     *
     * @returns {Page}
     */
    @Action('cms/loadPage')
    public loadPage: (payload: { id: string }) => Page

    public saveConfirmDialog = false
    public fab = false

    /**
     * Abre la pantalla y carga la vista previa de la página estática
     */
    public async openPreview () {
        this.togglePagePreview(true)
        await this.loadPagePreview()
    }

    get pageCreationDateFormated (): string {
        return moment.unix(this.page.createdAt).format('LLL')
    }

    get pageLastUpdateFormated (): string {
        return moment.unix(this.page.updatedAt).format('LLL')
    }

    public async created () {
        // tslint:disable-next-line:radix
        await this.loadPage({id: this.$route.params.id})
    }
}
